<template>
  <div class="ct-flex-row">
    <label class='flex-12'>
      Années
    <v-multiselect
      :value="$store.state.simulation.filtreAnnee"
      :options="typeAnnees"
      @input="updateFiltreAnnee"
      placeholder="Filtre"
      label="label"
      track-by="value"
      :searchable="false"
      :showLabels="false"
      :allow-empty="false"
      :disabled="$store.state.simulation.anneesSeches.length === 0"
    />
    </label>
    <label class="flex-12 has-tooltip" v-if="showIlot" v-tooltip="{ content : getTooltipMessage('filtre_ilot') }">
      <span>Ilôt</span>
    <v-multiselect
      :value="$store.state.simulation.filtreIlot"
      :options="ilots"
      @input="updateFiltreIlot"
      placeholder="Ensemble des ilôts"
      label="nom_ilot"
      track-by="id_ilot"
      :searchable="false"
      :showLabels="false"
      :allow-empty="false"
      openDirection="bottom"
    />
    </label>
    <label class="flex-12" v-if="showCulture">
      Culture de l'îlot
    <v-multiselect
      :value="$store.state.simulation.filtreCulture"
      :options="cultures"
      @input="updateFiltreCulture"
      placeholder="Ensemble des cultures"
      :custom-label="labelCulture"
      track-by="id_culture"
      :searchable="false"
      :showLabels="false"
      :allow-empty="false"
      :disabled="showIlot && $store.state.simulation.filtreIlot.id_ilot == null"
    />
    </label>
    <div class="item-flex-full"></div>
  </div>
</template>

<script>
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'resultat_filtre',
  mixins: [mixinTooltip],

  computed: {
    currentSimulation () {
      return this.$store.state.simulation.currentSimulation || {}
    },
    typeAnnees () {
      return this.$store.getters.typeAnnees
    },
    printempsSec () {
      return this.$store.getters.printempsSec
    },
    eteSec () {
      return this.$store.getters.eteSec
    },
    ilots () {
      return this.$store.getters.ilots
    },
    cultures () {
      return this.$store.getters.cultures
    },
    showIlot () {
      return ((this.$route.meta || {}).filtre || {}).ilot !== false
    },
    showCulture () {
      return ((this.$route.meta || {}).filtre || {}).culture !== false
    }
  },

  methods: {
    updateFiltreAnnee (val) {
      this.$store.commit('SET_FILTRE_ANNEE', val)
      this.$emit('changed')
    },

    updateFiltreIlot (ilot) {
      this.$store.commit('SET_FILTRE_ILOT', ilot)
      this.$store.commit('SET_FILTRE_CULTURE', null)
      this.$emit('changed')
    },

    updateFiltreCulture (culture) {
      this.$store.commit('SET_FILTRE_CULTURE', culture)
      this.$emit('changed')
    },

    labelCulture (culture) {
      return [culture.nom_culture, culture.nom_variete, culture.complement].filter(t => !!t).join(' - ')
    }
  }
}
</script>

<style>

</style>
